import type { PartialIngredient } from '@order/graphql';
import { DressingMode } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

// ────────────────────────────────────────────────────────────────────────────────

export const useLineItemDescription = (lineItem: LineItem) => {
  const { t } = useLocalizationContext();

  // ─── DRESSING MODE ──────────────────────────────────────────────────

  const dressingMode: DressingMode =
    lineItem.dressingMode ?? DressingMode.NotDressable;

  const dressingModeTexts: Record<DressingMode, string> = {
    [DressingMode.NotDressable]: '',
    [DressingMode.OnTheSide]: t('bag.lineItem.dressing-on-the-side'),
    [DressingMode.Mixed]: t('bag.lineItem.dressing-mixed-in'),
    [DressingMode.Removed]: t('bag.lineItem.dressing-removed'),
  };
  const dressingModeText = dressingModeTexts[dressingMode];

  // ─── BREAD ──────────────────────────────────────────────────────────

  const isBreadIncluded = lineItem.addedIngredients?.some(
    (addedIngredient) => addedIngredient.name === 'Bread',
  );
  const conditionalAddedBreadText = isBreadIncluded
    ? t('bag.lineItem.with-bread')
    : '';

  // ────────────────────────────────────────────────────────────────────

  return `${dressingModeText} ${conditionalAddedBreadText}`.trim();
};

// ────────────────────────────────────────────────────────────────────────────────

type LineItem = Readonly<{
  dressingMode?: DressingMode;
  addedIngredients?: ReadonlyArray<Partial<PartialIngredient>>;
  removedIngredients?: ReadonlyArray<Partial<PartialIngredient>>;
}>;
